import {
    Checkbox,
    FormControl,
    InputLabel,
    ListItemText,
    MenuItem,
    OutlinedInput,
    Select,
    SelectChangeEvent,
    useTheme,
} from '@mui/material'
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded'
import { ClientType } from '../../services/api/sharedTypes/Client'
import { convertClientTypeToString, convertStringToClientType } from '../../utils/client-utils'

interface ClientTypeSelectProps {
    selectedClientTypes: ClientType[]
    onSelectedClientTypesChange: (selectedClientTypes: ClientType[]) => void
}

const ClientTypeSelect: React.FC<ClientTypeSelectProps> = ({
    selectedClientTypes,
    onSelectedClientTypesChange,
}: ClientTypeSelectProps) => {
    const theme = useTheme()

    const handleChange = (event: SelectChangeEvent<typeof selectedClientTypes>) => {
        const {
            target: { value },
        } = event
        typeof value === 'string' ? onSelectedClientTypesChange(value.split(',').map(Number)) : onSelectedClientTypesChange(value)
    }

    return (
        <FormControl size='small' fullWidth style={{ marginTop: theme.spacing(1) }}>
            <InputLabel>Typ klienta</InputLabel>
            <Select
                multiple
                value={selectedClientTypes}
                onChange={handleChange}
                input={<OutlinedInput label='Typ klienta' style={{ background: theme.palette.customBackground.default, maxHeight: 36 }} />}
                renderValue={(selected) =>
                    selected
                        .map((clientType) => convertClientTypeToString(convertStringToClientType(Number(clientType))))
                        .join(', ')
                }
            >
                <MenuItem value={ClientType.Citizen} style={{ maxHeight: '36px' }}>
                    <Checkbox checked={selectedClientTypes.indexOf(ClientType.Citizen) > -1} />
                    Občan
                </MenuItem>
                <MenuItem value={ClientType.LegalEntity} style={{ maxHeight: '36px' }}>
                    <Checkbox checked={selectedClientTypes.indexOf(ClientType.LegalEntity) > -1} />
                    Právnická osoba
                </MenuItem>
                <MenuItem value={ClientType.Individual} style={{ maxHeight: '36px' }}>
                    <Checkbox checked={selectedClientTypes.indexOf(ClientType.Individual) > -1} />
                    Fyzická osoba
                </MenuItem>
                <MenuItem value={ClientType.NotSet} style={{ maxHeight: '36px' }}>
                    <Checkbox checked={selectedClientTypes.indexOf(ClientType.NotSet) > -1} />
                    Není nastaveno
                </MenuItem>
                <MenuItem style={{ borderTop: '1px solid gray', display: 'flex' }}>
                    <RefreshRoundedIcon style={{ marginLeft: theme.spacing(2), marginRight: theme.spacing(2) }} />
                    <ListItemText primary='Zrušit filtr' onClick={() => onSelectedClientTypesChange([])} />
                </MenuItem>
            </Select>
        </FormControl>
    )
}

export default ClientTypeSelect
